import React from "react";
import { useTranslation } from "react-i18next";
import "./facilities.css";

const Facility: React.FC<{
  icon: string;
  title: string;
  description: string;
}> = ({ icon, title, description }) => {
  return (
    <div className="col-md-4">
      <div
        className="single-facility animate-box"
        data-animate-effect="fadeInUp"
      >
        <span className={icon}></span>
        <h5>{title}</h5>
        <p>{description}</p>
        <div className="facility-shape">
          <span className={icon}></span>
        </div>
      </div>
    </div>
  );
};

const facilitiesNames = [
  "park",
  "clim",
  "safe",
  "wifi",
  "late",
  "cafe",
  "bouilloire",
  "frigo",
  "pmr",
];

const FacilitiesSection: React.FC = () => {
  const { t: tHome } = useTranslation("home");
  return (
    <section className="facilties section-padding">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="section-subtitle">
              {tHome("facilities.subtitle")}
            </div>
            <div className="section-title">{tHome("facilities.title")}</div>
          </div>
        </div>
        <div className="row">
          {facilitiesNames.map((name) => (
            <Facility
              key={name}
              icon={`custom-icon-${name}`}
              title={tHome(`facilities.items.${name}.title`)}
              description={tHome(`facilities.items.${name}.description`)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FacilitiesSection;
